module.exports = __webpack_public_path__ + "1c4693a58d8609ff374f2e21af8904fa.fbx";